import PropTypes from 'prop-types';
import PillCheckbox from 'Components/profile/PillCheckbox';

const InterestsSelectorNew = ({
  interests,
  interestsArray,
  onChange,
  selections,
}) => {
  return (
    <div className="interests-selector">
      <div className="interests-selector__inner">
        {interestsArray.map((interest) => (
          <PillCheckbox
            checked={selections.includes(interest)}
            image={`https://account.redbull.com/bundles/assets/static/img/${interest}.jpg`}
            key={interest}
            onChange={onChange}
            text={interests[interest].name}
            value={interest}
          />
        ))}
      </div>
    </div>
  );
};

InterestsSelectorNew.propTypes = {
  hasInterests: PropTypes.bool.isRequired,
  interests: PropTypes.object.isRequired,
  interestsArray: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  selections: PropTypes.array.isRequired,
  userInterests: PropTypes.array.isRequired,
};

export default InterestsSelectorNew;
